import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [], 

  type:[],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  
  SET_LIST(state, payload) {
    state.list = payload;
  },

  UPDATE_FUEL_PRICE(state, row) {
    const item = state.list.find((item) => item.id === row.id);
    Object.assign(item, row);
  },
  SET_FUEL_TYPE(state, payload) {
    state.type = payload;
  },
 
  
};

const actions = {

  list: (store, params) => {
    store.state.loading = true;
    return Service
      .get("fuel-management/fuel-price-history", params)
      .then((data) => {
        store.commit("SET_LIST", data.body);
        store.commit("SET_META", data.body);
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  fuelType: (store, params) => {
    store.state.loading = true;
    return Service
      .get("fuel-management/fuel-type", params)
      .then((data) => {
        store.commit("SET_FUEL_TYPE", data.body);
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  add: (store, { payload, filter }) => {
    store.state.loading = true;
    return Service
      .post("fuel-management/fuel-price-history", payload)
      .then(() => {
        store.dispatch("list", filter);
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return Service
      .put(`fuel-management/fuel-price-history/${params.id}`, params)
      .then((data) => {
        store.commit("UPDATE_FUEL_PRICE", data.body);
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    return Service.destroy(`fuel-management/fuel-price-history`,params);
  },
};

const getters = {
  
  getLoading(state) {
    return state.loading;
  },

  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getFuelType(state) {
    return state.type;
  },
  
};

const fuelPrices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default fuelPrices;
